// Module
var code = "<div aria-label=\"[[ this.trans('quote-element') ]]\" alt=\"[[ this.trans('quote-element') ]]\" title=\"[[ this.trans('quote-element') ]]\" class=\"flex flex-col items-baseline my-12 md:px-24 md:my-16\"> <div class=\"text-[26px] italic font-medium mb-4\">«[[quote]]»</div> <div class=\"font-mono text-active\">[[person]]</div> </div> ";
// Exports
export default code;